module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-fully-fenced-581.7185112edc458530.png"+" 581w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-fully-fenced-581.7185112edc458530.png",width: 581,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-fully-fenced-581.7185112edc458530.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-fully-fenced-581.7185112edc458530.png"},
        
        width: 581,
        height: 400
      }